window.addEventListener("DOMContentLoaded", () => {
	let tabs = document.querySelectorAll(".tabs-formation");
	if (tabs) {
		let tabs_nav = document.querySelectorAll(".tabnav li");
		tabs_nav.forEach((item) => {
			item.addEventListener("click", () => {
				let currenttabnav = document.querySelector(".tabnav li.current");
				let currenttab = document.querySelector(".tabs-wrapper .tab.current");
				if (currenttabnav) {
					currenttabnav.classList.remove("current");
				}
				if (currenttab) {
					currenttab.classList.remove("current");
				}
				item.classList.add("current");
				document.getElementById("tab-" + item.dataset.nav).classList.add("current");
			});
		});

		let first_tab = document.querySelector(".tabnav li");
		if (first_tab) {
			first_tab.click();
		}
	}
});
